import { Comment } from "@ant-design/compatible";
import {
  ArrowLeftOutlined,
  CaretRightFilled,
  CloseOutlined,
  EyeFilled,
  InteractionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Col, Divider, Image, Input, message, Row, Select, Space, Tooltip, Typography } from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import starfill from "../../../../../../assets/img/starfill.png";
import starregular from "../../../../../../assets/img/starregular.png";
import { maintenanceService } from "../../../../../../configs/constants";
import axios from "../../../../../../utils/axiosInceptor";
import { getPresignedImage } from "../../../../../../utils/media";

import { useDispatch, useSelector } from "react-redux";
import { getTicketByID } from "../../ducks/actions";

import { FeatureToggle } from "../../../../../../feature-flags";
import { useSmoothLoading } from "../../../../../../hooks/useSmoothLoading";
import { dateByformat } from "../../../../../../utils/dateHelper";
import { Popup } from "../../../../../atoms/Popup";
import { SectionLoader } from "../../../../../atoms/SectionLoader/SectionLoader";
import ReAssignTechnician from "../ReAssignTechnician";
import { ServiceChargesForm } from "../ServiceChargesSection";

var _ = require("lodash");

const { Title, Text } = Typography;
const { Search } = Input;
const priorityOptions = [
  { value: "p1", label: "P1" },
  { value: "p2", label: "P2" },
  { value: "p3", label: "P3" },
  { value: "p4", label: "P4" },
  { value: "p5", label: "P5" },
];
const ViewTicket = (props) => {
  const { data, onCancel, assignTech, onActivityLog, onSubmitTicket } = props;

  const {
    isLoading: isLoadingComments,
    startLoading: startLoadingComments,
    stopLoading: stopLoadingComments,
  } = useSmoothLoading();
  const dispatch: any = useDispatch();
  const [review, setReview] = useState({ rating: 5, review: "" });
  const [comments, setComments] = useState(null);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [selectedTicket, setSelectedTickets] = useState();
  const [activityData, setActivityData] = useState([]);
  const [totalImageURL, setTotalImageURL] = useState([]);
  const [totalVideoUrls, setTotalVideoUrls] = useState([]);
  const [techtotalImageURL, setTechtotalImageURL] = useState([]);
  const [techtotalVideoUrls, setTechtotalVideoUrls] = useState([]);
  const [riccuranceTicket, setRiccuranceTicket] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [startRate, setStartRate] = useState(null);
  const [priority, setPriority] = useState("default");

  const ticketReviews = [];
  const ticketData = useSelector((state: any) => state.tickets.getTicketById) || {};

  let status = ticketData?.ticketStatus;
  const ticketId = data?.parentTicketId && data?.followUp ? data?.parentTicketId : data?.ticketId;

  useEffect(() => {
    dispatch(getTicketByID(ticketId));
  }, [ticketId]);

  useEffect(() => {
    if (ticketReviews) {
      setReview(ticketReviews?.[0]);
    }
  }, [ticketReviews]);

  const viewActivityLogTicket = async (data) => {
    props.onActivityLog(data);
  };

  useEffect(() => {
    if (ticketData) {
      if (ticketData?.ticketStatusHistory?.length > 0) {
        let sortedStatus = _.sortBy(ticketData?.ticketStatusHistory, [(obj) => moment(obj.createdAt)]).reverse();
        setActivityData(sortedStatus);
      }
      const starRate = ticketData?.ratingAndReview?.rating;

      if (ticketData?.priority) {
        setPriority(ticketData.priority === "default" ? "Select priority" : ticketData.priority);
      }

      if (starRate) {
        let ticketRateArr = [];
        for (let rate = 1; rate <= 5; rate++) {
          ticketRateArr.push(
            <img alt="Ticket" src={rate <= starRate ? starfill : starregular} width={25} height={25} />
          );
        }
        setStartRate(ticketRateArr);
      }

      (async () => {
        let totalImages = [];
        let totalVideos = [];
        if (ticketData.documents && ticketData.documents.length > 0) {
          ticketData.documents.map((x) => {
            if (x?.documentId && !x?.type.includes("mp4")) {
              totalImages.push(x.documentId);
            } else {
              totalVideos.push(x.documentId);
            }
          });
          const images = await getMedia(totalImages);
          const videos = await getMedia(totalVideos);

          setTotalImageURL(images);
          setTotalVideoUrls(videos);
        }

        let techtotalImages = [];
        let techtotalVideos = [];
        if (ticketData?.technicianDocuments && ticketData?.technicianDocuments?.length > 0) {
          ticketData.technicianDocuments.map((x) => {
            if (x?.documentId && !x?.type.includes("mp4")) {
              techtotalImages.push(x.documentId);
            } else {
              techtotalVideos.push(x.documentId);
            }
          });
          const images = await getMedia(techtotalImages);
          const videos = await getMedia(techtotalVideos);
          setTechtotalImageURL(images);

          setTechtotalVideoUrls(videos);
        }
      })();
    }
  }, [ticketData]);

  const getComments = useCallback(async () => {
    try {
      startLoadingComments();
      const response = await axios.get(`${maintenanceService}/maintenance/ticket/getComments/${data?.ticketId}`);
      setComments(response?.data?.result?.data);
    } catch (e) {
      console.error("Failed to fetch comments:", e);
      message.error("Failed to fetch comments");
      setComments([]);
    } finally {
      stopLoadingComments();
    }
  }, [maintenanceService, data?.ticketId, startLoadingComments, stopLoadingComments]);

  useEffect(() => {
    if (data?.ticketId) {
      getComments();
    }
  }, [data?.ticketId]);

  const onSubmit = () => {
    dispatch(getTicketByID(ticketId));
    setVisible(false);
    onSubmitTicket();
  };

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          Modify Ticket
        </Title>
      ),
      content: <ReAssignTechnician ticket={selectedTicket} onBack={() => setVisible(false)} onSubmit={onSubmit} />,
      width: 650,
    },
  ];

  const ticketAction = (type) => {
    setVisible(true);
    setSelectedTickets({ ...ticketData, ...{ ticketStatus: type } });
  };

  const popupProps = {
    closable: trigger == 0 ? true : false,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  const getTicketStatus = () => {
    return activityData[0]?.status
      ?.split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const addComment = async (commentText) => {
    const url = `${maintenanceService}/maintenance/ticket/comment`;
    try {
      const res = await axios.post(url, {
        comment: commentText,
        type: "public",
        moduleId: ticketId,
      });
      setInputValue("");

      message.success("Comment added successfully");
      getComments();
    } catch (e) {
      const { response } = e;
      message.error(response?.data?.message);
    }
  };

  const capitalizeFirstLetter = (str = "") => str?.charAt(0)?.toUpperCase() + str?.slice(1);

  function formatDate(date) {
    const currentDate = new Date();
    const providedDate = new Date(date);

    if (providedDate.toDateString() === currentDate.toDateString()) {
      const timeDiff = Math.abs(currentDate.getTime() - providedDate.getTime());
      const diffInHours = Math.floor(timeDiff / (1000 * 60 * 60));
      const diffInMinutes = Math.floor(timeDiff / (1000 * 60));

      if (diffInHours === 0) {
        if (diffInMinutes === 0) {
          return "Less than a minute ago";
        } else {
          return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
        }
      } else {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
      }
    } else if (providedDate < currentDate) {
      const dateOptions = { year: "numeric", month: "long", day: "numeric", weekday: "long" } as const;
      return providedDate.toLocaleDateString(undefined, dateOptions);
    } else {
      return "Invalid date";
    }
  }

  const getMedia = async (totalImages) => {
    if (totalImages?.length > 0) {
      const result = await getPresignedImage(totalImages); //change
      if (result && result.length > 0) {
      } else {
        message.error("Something wrong with Media");
      }
      return result;
    }
    return [];
  };

  const goToRecurringTicket = async () => {
    setRiccuranceTicket(ticketId);
    dispatch(getTicketByID(ticketData.parentTicketId));
  };

  const goToOldTicket = async () => {
    dispatch(getTicketByID(ticketId));
    setTimeout(() => {
      setRiccuranceTicket("");
    }, 2000);
  };

  const changePriority = async (e) => {
    if (e.value === "p1" || e.value === "p2" || e.value === "p3" || e.value === "p4" || e.value === "p5") {
      setPriority(e.value);
      const url = `${maintenanceService}/maintenance/ticket/${ticketId}`;
      try {
        const res = await axios.patch(url, {
          priority: e.value,
        });

        message.success("Priority changed successfully");
        dispatch(getTicketByID(ticketId));
      } catch (e) {
        const { response } = e;
        message.error(response?.data?.message);
      }
    }
  };

  const TooltipContent = ({ data }) => {
    return (
      <div>
        <div>
          <strong>Low Rating Reason</strong>
        </div>
        <div>{data}</div>
      </div>
    );
  };

  const actionButtonStyles = {
    width: "7.25rem",
    height: "2.25rem",
    borderRadius: "8px",
  };

  return (
    <Row gutter={24}>
      <Row className="w-100">
        <Col span={12}>
          {riccuranceTicket && (
            <Button
              style={{ float: "left" }}
              className="p-0 h-auto w-auto ag-default mb-1"
              type="link"
              size="large"
              onClick={goToOldTicket}
              icon={<ArrowLeftOutlined />}
            />
          )}
        </Col>
        <Col span={12}>
          {!props.onBack && (
            <Button
              style={{ float: "right" }}
              className="p-0 h-auto w-auto ag-default mb-1"
              type="link"
              size="large"
              onClick={onCancel}
              icon={<CloseOutlined />}
            />
          )}
        </Col>
      </Row>
      <Row gutter={24} className="w-90">
        <Col span={14}>
          <Row gutter={[32, 24]}>
            <Col span={24}>
              <Space size={2} className="w-100">
                <Title level={5} className="ag-primary">
                  {ticketData?.srNumber}
                </Title>
                {ticketData?.isPaidService && (
                  <Title level={5} className="ag-primary">
                    {ticketData?.isPaidService && "(Paid)"}
                  </Title>
                )}
                {ticketData?.recurrence ? (
                  <InteractionOutlined
                    style={{ fontSize: 28, color: "#184461", paddingBottom: 8, paddingLeft: 11 }}
                    onClick={() => goToRecurringTicket()}
                  />
                ) : null}
              </Space>
              <Space size={2} className="w-100" direction="vertical">
                <Title level={5} className="ag-primary">
                  {`${capitalizeFirstLetter(ticketData?.category?.name)} - ${capitalizeFirstLetter(
                    ticketData?.subCategory?.name
                  )}`}
                </Title>
                <Title level={5} className="ag-primary">
                  {capitalizeFirstLetter(ticketData?.propertyName)} - {ticketData?.unitNumber}
                </Title>
              </Space>
            </Col>

            <Col span={24}>
              <Space size={2} className="w-100" direction="vertical">
                <Row>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={8}>
                    <Text className="ag-primary" strong>
                      Status
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text className="smallFont14 fontWeight600">{getTicketStatus()}</Text>
                    <Text
                      className="ag-primary"
                      onClick={() => viewActivityLogTicket(ticketData)}
                      strong
                      underline
                      style={{ cursor: "pointer", marginLeft: 10 }}
                    >
                      View Details
                    </Text>
                  </Col>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={8}>
                    <Text className="ag-primary" strong>
                      Assigned to
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text className="smallFont14 fontWeight600">{ticketData?.technician?.name}</Text>
                  </Col>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={8}>
                    <Text className="ag-primary" strong>
                      Date and time
                    </Text>
                  </Col>
                  <Col span={12}>
                    {
                      <Text className="smallFont12 fontWeight600">
                        {dateByformat(ticketData?.preferredDate, "DD-MM-YYYY")} |{" "}
                        {ticketData?.preferredTimeStart &&
                          moment(ticketData?.preferredTimeStart, "hh:mm:ss").format("LT")}{" "}
                        {ticketData?.preferredTimeEnd &&
                          `to ${moment(ticketData?.preferredTimeEnd, "hh:mm:ss").format("LT")}`}
                      </Text>
                    }
                  </Col>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={8}>
                    <Text className="ag-primary" strong>
                      Priority
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Select
                      value={priority}
                      onChange={(e) => changePriority(e)}
                      filterOption={(input, option) =>
                        (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                      }
                      labelInValue
                      placeholder={`Select priority`}
                      options={priorityOptions}
                    />
                  </Col>
                </Row>
              </Space>
            </Col>
          </Row>

          <FeatureToggle flags="14136-paid-maintenance">
            {ticketData?.isPaidService && ticketData?.onSitePaymentForServices && (
              <Row className="mt-4">
                <Divider />
                <ServiceChargesForm onSubmitSuccess={getComments} />
              </Row>
            )}
          </FeatureToggle>
        </Col>
        <Col span={10}>
          {startRate && (
            <Row>
              <Col span={24}>
                {ticketData?.ratingAndReview?.lowRatingReason ? (
                  <Tooltip title={<TooltipContent data={ticketData?.ratingAndReview?.lowRatingReason} />}>
                    <Row>{startRate && startRate.map((item, key) => item)}</Row>
                  </Tooltip>
                ) : (
                  <Row>{startRate && startRate.map((item, key) => item)}</Row>
                )}
              </Col>
            </Row>
          )}
          {ticketData?.description && (
            <Row>
              <Col span={24}>
                <Space size={2} className="w-100" direction="vertical">
                  <Title level={4}>Description</Title>
                  <Text>{ticketData?.description}</Text>
                </Space>
              </Col>
            </Row>
          )}
          {ticketData?.ratingAndReview?.lowRatingReason && (
            <Row>
              <Col span={24}>
                <Space style={{ marginBottom: "10px" }} size={0} className="w-100" direction="vertical">
                  <Title level={5}>Low Rating Reason</Title>
                  <span>{ticketData?.ratingAndReview?.lowRatingReason}</span>
                </Space>
              </Col>
            </Row>
          )}
          <Row>
            <Col span={24}>
              <Space size={[8, 0]} wrap>
                {totalImageURL?.map((e, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Button className="ticket_thumb" type="link" size="large">
                        <Image preview={true} alt="Ticket" src={e} width="115" height="118" />
                        <EyeFilled className="thumb_icon" />
                      </Button>
                    </React.Fragment>
                  );
                })}
                {totalVideoUrls?.map((e, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Button className="ticket_thumb video_thumb" type="link" size="large">
                        <video src={e} controls width="115" height="118"></video>
                        <CaretRightFilled className="thumb_icon" />
                      </Button>
                    </React.Fragment>
                  );
                })}

                {techtotalImageURL?.map((e, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Button className="ticket_thumb technician" type="link" size="large">
                        <Image preview={true} alt="Ticket" src={e} width="115" height="118" />
                        <EyeFilled className="thumb_icon" />
                      </Button>
                    </React.Fragment>
                  );
                })}
                {techtotalVideoUrls?.map((e, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Button className="ticket_thumb video_thumb technician" type="link" size="large">
                        <video src={e} controls width="115" height="118"></video>
                        <CaretRightFilled className="thumb_icon" />
                      </Button>
                    </React.Fragment>
                  );
                })}
              </Space>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Space size={2} className="w-100" direction="vertical">
                <Title level={4}>Tenant Details</Title>
                <Row>
                  <Col span={12}>
                    <Text className="ag-primary" strong>
                      Name
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text className="smallFont14 fontWeight600">{ticketData.tenantName}</Text>
                  </Col>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={12}>
                    <Text className="ag-primary" strong>
                      EmailID
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text className="smallFont14 fontWeight600">{ticketData?.tenantemail}</Text>
                  </Col>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={12}>
                    <Text className="ag-primary" strong>
                      Mobile Number
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text className="smallFont14 fontWeight600">{ticketData?.tenantMobileNumber}</Text>
                  </Col>
                  <Col span={24}>
                    <Divider />
                  </Col>
                  <Col span={12}>
                    <Text className="ag-primary" strong>
                      Alternate Number
                    </Text>
                  </Col>
                  <Col span={12}>
                    <Text className="smallFont14 fontWeight600">{ticketData?.alternateNumber}</Text>
                  </Col>
                </Row>
              </Space>
            </Col>
          </Row>

          <Row>
            <Divider />
            <Title level={4}>Comments</Title>
            <Search
              placeholder="Add your comments"
              allowClear
              enterButton="Add"
              size="large"
              onChange={(e) => setInputValue(e.target.value)}
              value={inputValue}
              onSearch={addComment}
            />
            <Row className="w-100">
              <SectionLoader isLoading={isLoadingComments} containerStyle={{ height: "3rem" }}>
                {comments?.length > 0 &&
                  comments.map((comment) => (
                    <div key={comment?.ticketCommentId} className="w-100">
                      <Comment
                        author={<a>{comment?.commentBy?.name}</a>}
                        avatar={<Avatar icon={<UserOutlined />} alt={comment?.commentBy?.name} />}
                        content={<p>{comment?.comment}</p>}
                        datetime={
                          <Tooltip title={formatDate(comment?.createdAt)}>
                            <span>{formatDate(comment?.createdAt)}</span>
                          </Tooltip>
                        }
                      />
                      <Divider />
                    </div>
                  ))}
              </SectionLoader>
            </Row>
          </Row>
        </Col>
      </Row>

      <Row className="w-100">
        {status !== "issue_resolved" && (
          <Col style={{ width: "100%", display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
            <Button style={actionButtonStyles} type="primary" onClick={() => ticketAction("reassign")}>
              Reassign
            </Button>
            <Button style={actionButtonStyles} type="primary" onClick={() => ticketAction("reschedule")}>
              Reschedule
            </Button>
            <Button style={actionButtonStyles} type="primary" danger onClick={() => ticketAction("close")}>
              Close
            </Button>
          </Col>
        )}
      </Row>
      <Popup destroyOnClose={true} {...popupProps} />
    </Row>
  );
};

export default ViewTicket;
